<template>
  <div>
    <div
      v-for="student in dataList"
      :key="student.leaveId"
      class="fb fb-cross-start fb-main-start mt-12 font-28"
    >
      <div
        @click="handlerClickItem(student)"
        class="mr-16 w-32 h-32 avator-image"
        :class="`avator${student.sex}-1`"
      >
      </div>
      <div class="item-flex-1 bb" @click="handlerClickItem(student)">
        <div class="fb fb-between-center">
          <div>
            <div class="p-6-0 lh-24 fb fb-cross-center fb-main-start">
              <span
                class="c-171A1D font-34 text-ellipsis inline-block max-w-120"
                >{{ student.personName }}</span
              >
              <span
                class="iconfont pl-4"
                v-show="!cpCurIsGuardianRole && student.sex"
                :style="{
                  color: student.sex === 1 ? '#006AFE' : '#FF4D94'
                }"
                >{{ student.sex === 1 ? '&#xe685;' : '&#xe686;' }}</span
              >
              <span
                class="ml-12 font-24 bd-radio-12 border-171A1D h-22 min-w-40 fb-center-center c-171A1D-60 p-0-8"
                >{{ student.leaveTypeName }}</span
              >
            </div>

            <p class="c-171A1D-40 lh-20"
              >开始时间：{{
                getSegTime(
                  +student.startTime,
                  +student.endTime,
                  student.leaveDurationUnit
                )[0].replace(/\w{4}\./, '')
              }}</p
            >
            <p class="c-171A1D-40 lh-20 pb-16"
              >结束时间：{{
                getSegTime(
                  +student.startTime,
                  +student.endTime,
                  student.leaveDurationUnit
                )[1].replace(/\w{4}\./, '')
              }}
            </p></div
          >
          <common-leave-status
            class="font-30"
            :border="true"
            :status="student.approveStatus"
          ></common-leave-status>
        </div>
        <div
          v-if="
            allowLeaveBackCertificate
              ? student.backSchoolStatus > 0
              : student.backSchoolStatus > 1
          "
          class="bt h-56 back-con fb fb-main-between fb-cross-center pr-12"
          @click.stop="
            handlerClickList(
              student.backSchoolStatus,
              student.dingPersonId,
              student.leaveId
            )
          "
        >
          <div class="title font-34">返校证明</div>
          <div class="status font-30">
            <span
              :style="{
                color: BACK_SCHOOL_STATUS[+student.backSchoolStatus || 1].color
              }"
            >
              {{ BACK_SCHOOL_STATUS[+student.backSchoolStatus || 1].content }}
            </span>
            <span class="iconfont c-171A1D-40">&#xe68d;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonLeaveStatus } from '@/components'
import { BACK_SCHOOL_STATUS } from '@/utils/constUtils'
import { timeFormat, unitDayTime } from '@/utils/comUtils'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  name: '',
  components: { commonLeaveStatus },
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      BACK_SCHOOL_STATUS
    }
  },
  computed: {
    allowLeaveBackCertificate() {
      return this.$store.getters.allowLeaveBackCertificate
    },
    cpCurIsGuardianRole() {
      return ((this.$store || {}).getters || {}).curIsGuardian || false
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getSegTime(startTime, endTime, leaveDurationUnit) {
      if (leaveDurationUnit === 1) {
        return [
          timeFormat(new Date(startTime), 'MM.DD hh:mm'),
          timeFormat(new Date(endTime), 'MM.DD hh:mm')
        ]
      } else {
        return unitDayTime(startTime, endTime, 'YYYY.MM.DD hhmm')
      }
    },
    handlerClickItem(item) {
      this.$emit('click', item)
    },
    handlerClickList(backSchoolStatus, studentDingIds, leaveId) {
      let url = '/leave/backdetail'
      //  返校证明状态 1：未上传 2：待审核 3：已通过 4：已拒绝 5: 已失效
      if (this.allowLeaveBackCertificate) {
        const _goBack =
          (this.curIsGuardian || this.isStudent) && backSchoolStatus === 1
        _goBack && (url = '/leave/back')
      }

      this.$emit('clickBack', url, studentDingIds, leaveId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
